import { AxiosResponse } from 'axios'
import { generalServiceV1API, generalServiceV2API } from '@/store/api-instance'
import { IInvoicesOlsaRequest } from '@/store/modules/invoicesOlsa/interfaces/invoicesOlsa/IInvoicesOlsaRequest'
import { IInvoicesOlsaResponse } from '@/store/modules/invoicesOlsa/interfaces/invoicesOlsa/IInvoicesOlsaResponse'
import { ISelectedInvoiceOlsaRequest } from '../interfaces/selectedInvoiceOlsa/ISelectedInvoiceOlsaRequest'
import { ISelectedInvoiceOlsaResponse } from '../interfaces/selectedInvoiceOlsa/ISelectedInvoiceOlsaResponse'
import { IDropdownItems } from '@/store/modules/common/interface/IDropdownItems'
import { IBulkDownload } from '../../invoicesOlsa/interfaces/IBulkDocument'

export const invoicesOlsaAPI = {
  async getInvoicesOlsa (dto: IInvoicesOlsaRequest): Promise<IInvoicesOlsaResponse> {
    const response: AxiosResponse<IInvoicesOlsaResponse> = await generalServiceV2API.get(
      'invoiceolsa/getdocuments',
      { params: dto }
    )
    return response.data
  },
  async getSelectedInvoiceOlsa (dto: ISelectedInvoiceOlsaRequest): Promise<ISelectedInvoiceOlsaResponse> {
    const response: AxiosResponse<ISelectedInvoiceOlsaResponse> = await generalServiceV1API.post(
      'invoiceolsa/getdocument',
      dto
    )
    return response.data
  },
  async getDocumentTypes (): Promise<IDropdownItems> {
    const response: AxiosResponse<IDropdownItems> = await generalServiceV1API.get('invoiceolsa/getdocumenttypes')
    return response.data
  },
  async fetchBulkDocuments (dto: IBulkDownload[]): Promise<Blob> {
    const response: AxiosResponse = await generalServiceV2API.post<Blob>('invoiceolsa/getdownloadzipdocumentsbulk', dto, {
      responseType: 'blob'
    })
    return response.data
  }
}
